var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReturnHistoryActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC72C",
  d: "M1.832 2.75h17.832v19.01H1.832Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC72C",
  d: "M1.082 2h19.332v20.51H1.082Zm17.832 1.5H2.582v17.51h16.332Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m13.261 10.437-2.513-1.263-2.512 1.263V2.753h5.025Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m14.014 11.65-3.263-1.64-3.263 1.64V2h6.525ZM8.989 3.5v5.717l1.763-.886 1.763.886V3.5ZM20.142 18.051h-8.713v-1.5h8.713a2.187 2.187 0 0 0 2.359-1.952 2.187 2.187 0 0 0-2.359-1.952v-1.5a3.676 3.676 0 0 1 3.859 3.452 3.676 3.676 0 0 1-3.859 3.452"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m13.204 20.115-2.835-2.835 2.793-2.793 1.061 1.061-1.732 1.732 1.775 1.775Z"
})));
export { SvgReturnHistoryActive as ReactComponent };
export default "/_next/static/images/return_history-active.svg";